import React from 'react'

import clsx from 'clsx'

import ClickoutWrapper from 'components/ClickoutWrapper'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Logo from 'components/Logo'
import Rating from 'components/Rating'
import { useEventContext } from 'context/EventContext'

import classes from './Header.module.scss'

const Header = ({ listing, isMain, listingPosition }) => {
  const { addEvent } = useEventContext()

  const hasLink = listing.is_premium || !isMain

  return (
    <>
      <ClickoutWrapper
        url={isMain ? undefined : listing.cta_urls.detail}
        className={classes.logoContainer}
        listingPosition={listingPosition}
        {...addEvent({
          name: 'engagement_product_click',
          engagementComponent: 'product_alternatives-comparison',
          engagementDestination: 'go-to_product_details',
          engagementDetails: 'logo_product',
          productClickPosition: listingPosition,
        })}
      >
        <Logo className={classes.logo} src={`${listing.logo_url}`} alt={`${listing.name} logo`} size={44} />
      </ClickoutWrapper>
      <div className={classes.productInfoContainer}>
        <ClickoutWrapper
          isClickout={listing.is_premium}
          url={hasLink ? listing.cta_urls.cta : undefined}
          buyerIntentProductId={listing.global_product_id}
          buyerIntentSourceLocation="listing-detail/alternative-header:name"
          buyerIntentTrackAdClick={listing.is_premium}
          data-testid="listing-item_text-link_product-name"
          listingPosition={listingPosition}
          {...addEvent({
            productClickPosition: listingPosition,
            name: listing.is_premium ? 'engagement_product_clickout' : 'engagement_product_click',
            engagementComponent: 'product_alternatives-comparison',
            engagementDestination: listing.is_premium ? 'go-to_vendor-website' : 'go-to_product_details',
            engagementDetails: 'text-link_product-name',
          })}
        >
          <Link variant="heading-xs" className={clsx(classes.listingName, { [classes.noLink]: !hasLink })}>
            <span className={classes.productName}>{listing.name} </span>
            {hasLink && listing.is_premium && (
              <Icon className={classes.clickoutIcon} icon={['far', 'external-link']} size="8" />
            )}
          </Link>
        </ClickoutWrapper>
        <Rating.Link
          className={classes.rating}
          href={listing.cta_urls.reviews}
          average={listing.rating_avg}
          totals={listing.num_reviews}
          isCompact
          size="small"
          {...addEvent({
            name: 'engagement_product_click',
            engagementDetails: 'text-link_number-reviews',
            engagementDestination: 'go-to_product-reviews',
          })}
        />
      </div>
    </>
  )
}

export default Header
